import React from 'react'
import LoginTemplate from './Login'

export default React.createClass({
    render(){
        return <LoginTemplate />
    }
});


// WEBPACK FOOTER //
// app/views/Login/index.js